<div class="modal-header">
  <h4>{{title}}</h4>
</div>

<div class="modal-body {{ msgCss }}">{{message}}</div>

<div class="modal-footer">
  <button *ngIf="cancel" class="btn btn-default btn-warning" (click)="onCancel()">{{ (txtCancel ? txtCancel : 'Cancel') | translate}}</button>
  <button *ngIf="showChangeAccount" class="btn btn-default" (click)="onChangeAccount()">{{'ChangeAccount' | translate}}</button>
  <button class="btn btn-default btn-primary" (click)="onOk()">{{ (txtOk ? txtOk : 'Ok') | translate}}</button>
</div>
